var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1a173ab7948bb74d70df22372add9eb9ec8a11aa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rprpcity-website@rprp-u9"]={id:"1a173ab7948bb74d70df22372add9eb9ec8a11aa"};
      